var _defs, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f766e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#14b8a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67e8f9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "40%",
    cy: "25%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "icons",
    width: 240,
    height: 240,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.26,
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 68,
    width: 116,
    height: 52,
    rx: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 68 v52",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 180                  c-18 -18 -46 -18 -64 0                  c-18 18 -18 46 0 64                  l64 64                  l64 -64                  c18 -18 18 -46 0 -64                  c-18 -18 -46 -18 -64 0z",
    transform: "translate(0 -68) scale(0.26) translate(340 640)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 26,
    fill: "#ffffff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#glow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#icons)",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 220,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380,
    cy: 220,
    r: 240,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 260,
    r: 160,
    fill: "#f59e0b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero3);
export default __webpack_public_path__ + "static/media/hero-3.8ff8e1639d53598b48d5ad6543326249.svg";
export { ForwardRef as ReactComponent };